
import { defineComponent } from "vue";

export default defineComponent({
  name: "BoundaryFilter",
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    value: {
      get(): boolean {
        return this.checked;
      },
      set(val: boolean) {
        this.$emit("update:checked", val);
      },
    },
  },
});
